import { environment } from "environments/environment";

export const locale = {
  lang: "en",
  data: {
    MENU: {
      EXAMPLE: "Example",
      TABLE: "Table",
      FORM: "From",
    },
    GENERAL: {
      FILTERS: "Filters",
      RESET_FILTERS: "Reset filters",
      LOADING: "Loading...",
      ADD: "Add",
      EDIT: "Edit",
      DELETE: "Delete",
      ERROR: "Error",
      RECOVER_DATA_ERR: "The data couldn't be restored",
      CODE: "Code",
      DAY: "Day",
      DESCRIPTION: "Description",
      ACTIONS: "Actions",
      OK: "OK",
      CANCEL: "Cancel",
      CORRECT_UPDATE: "Updated successfully",
      BAD_UPDATE: "Update unsuccessful",
      CORRECT_SAVE: "Created successfully",
      BAD_SAVE: "Couldn't create",
      LOGIN: "Login",
      USER_CODE: "User code",
      LANGUAGE: "Language",
      USER: "User",
      PLANIFICATION: "Planification",
      MACHINES: "Machines",
      ERROR_RECOVERING_DATA: "Error recovering data",
      MACHINE_NOT_SELECTED: "Machine not selected",
      OFFLINE: "Offline",
      SELECT: "Select",
      SELECT_MACHINE: "Select machine",
      SELECT_OF: "Select an OF",
      ONLY_ASSIGNED_TO_THIS_MACHINE: "Only assigned to this machine",
      SHOW_UNASSIGNED: "Include unassigned",
      SEARCH_OF: "Search OF",
      PREPARE_MACHINE: "Prepare machine",
      CONNECTION_LOST: "Connection lost",
      CONNECTION_LOST_ERROR:
        "Connection lost, the application cannot work properly",
      START: "Start",
      PROD: "Production",
      IDLE: "Stopped",
      EMERG: "Emergency",
      PREP: "Preparation",
      OF_NUMBER: "OF number",
      REFERENCE: "Reference",
      PHASE: "Phase",
      PREPARED_BY: "Prepared by",
      SELECT_NEW_OF: "Select new OF",
      START_PRODUCTION: "Start production",
      START_DATE: "Start date",
      END_DATE: "End date",
      MACHINE: "Machine",
      OF: "OF",
      QUANTITY: "Quantity",
      OBSERVATIONS: "Observations",
      PRODUCTION_SHEET: environment.eurogerm
        ? "Production sheet"
        : "Observations",
      NO_PRODUCTION_SHEET: environment.eurogerm
        ? "There is no production sheet"
        : "There are no observations",
      CLOSE: "Close",
      PREPARATION_ENDED: "Preparation ended",
      PRODUCTION_ENDED: "Production ended",
      NO_PLANIFICATIONS: "Currently, you don't have any planification",
      SELECT_REFERENCE: "Select reference",
      MULTIPLE_MACHINES:
        "The selected OF is configured to be produced on another machine. On which machine do you want to produce the OF?",
      COMPONENTS: "Components",
      TIME_PREPARATION: "Preparation time",
      TIME_PRODUCTION: "Production time",
      TIME_LEFT: "Time left",
      PRODUCED_BY: "Produced by",
      PRODUCTION: "Production",
      PIECES_OK: "Pieces OK",
      PIECES_NOK: "Pieces NOK",
      ASSIGN_TO_PRODUCTION: "Assign to production",
      ASSIGN_UNASSIGNED: "Pieces have been produced out of production",
      ASSIGN_UNASSIGNED_MESSAGE:
        "{{count}} pieces have been produced since the last production. The first one was produced on {{startDate}} and the last one was produced on {{endDate}}.",
      DISCARD: "Discard",
      ASSIGN: "Assign",
      PROTOTYPE: "Prototype",
      PRODUCTION_TYPE: "Production type",
      JUSTIFY_NOK: "Justify NOK",
      NOK_JUSTIFIED_PIECES: "NOK justified pieces",
      TOTAL_PIECES_NOK: "Total pieces NOK",
      STOP_PRODUCTION: "End production",
      ERROR_STARTING: "Error trying to start production",
      STOP_PREPARATION: "End preparation",
      CADENCE: "Cadence",
      CONTAINER_CODE: environment.eurogerm ? "Cycle code" : "Container code",
      CONTAINER: environment.eurogerm ? "Cycle" : "Container",
      START_CONTAINER: "Start",
      STOP_CONTAINER: environment.eurogerm ? "End cycle" : "End container",
      MUST_CLOSE_CONTAINER: environment.eurogerm
        ? "You must close all the open cycles before ending production"
        : "You must close all the open containers before ending production",
      START_CONTAINER_ERROR: environment.eurogerm
        ? "Could not start the cycle"
        : "Could not start the container",
      STOP_CONTAINER_ERROR: environment.eurogerm
        ? "Could not end the cycle"
        : "Could not end the container",
      OF_EMPTY: "Currently, there are no OF's for this machine",
      NO_OBSERVATIONS: "There are no observations",
      SELF_SIGNED_CERT: "Self-signed certificate",
      SELF_SIGNED_CERT_MESSAGE:
        "You must accept the certificate to be able to communicate with the machine",
      DOCUMENTATION: "Documentation",
      NAME: "Name",
      VIEW_FILE: "View file",
      PRINT_LAST_PRODUCTION: "Print last label",
      CONTROLS: "Controls",
      AS: "Serial boot",
      FS: "End of serie",
      ITU: "Shift start",
      DA: "After a breakdown",
      PENDING_POINTS: "Pending quality questionnaires",
      PENDING_POINT: "Quality questionary",
      OF_DE: "of",
      BACK: "Back",
      NEXT: "Next",
      FINISH: "Finish",
      SUBMIT: "Submit",
      PIECES: "Pieces",
      ERROR_STOPPING: "The production could not be finished",
      EMERGENCY_STOP: "Emergency stop",
      PROPOSE_STOP: "Proposed stop",
      STOP: "Stop",
      SHUTDOWN: "Shutdown",
      OTHERS: "Others",
      MACHINE_ON: "Machine on",
      PREPARATION: "Preparation",
      JUSTIFY_STOPS: "Justify stops",
      JUSTIFY_STOP: "Justify stop",
      MANUAL: "Manual",
      STOP_TIME: "Stop time",
      JUSTIFY: "Justify",
      READ: "Read",
      QR_CODE: "Label QR code",
      COMPONENT_NAME: "Component name",
      EXPIRATION: "Expiration",
      ACCEPT_EXPIRED_COMPONENT: "Accept expired component",
      RESPONSIBLE_VALIDATION: "Responsible validation",
      RESPONSIBLE_USER_CODE: "Responsible user code",
      ACCEPT: "Accept",
      NO_LAST_PRODUCTION: "Could not find last production",
      NO_LAST_CONTAINER: environment.eurogerm
        ? "Could not find last cycle"
        : "Could not find last container",
      DATE: "Date",
      EXTRA_INFORMATION: "Extra information",
      CONFIGURATION: "Configuration",
      CONNECTING: "Connecting",
      OPEN: "Open",
      CLOSING: "Closing",
      CLOSED: "Closed",
      CURRENT_VERSION: "Current Version",
      CHANGE: "Change",
      CONFIGURATION_PASSWORD: "Configuration password",
      INCORRECT_PASSWORD: "Incorrect password",
      TRY_AGAIN: "Try again",
      TEAMS: "Teams",
      TEAM: "Team",
      SELECT_TEAM: "Select team",
      WORKERS_NOT_FOUND: "Workers not found",
      COMPONENT_INDEX: environment.eurogerm
        ? "Cycle {0} de {1}"
        : "Container {0} de {1}",
      DIVIDE: "Divide",
      ERROR_UPDATING_MEMBERS: "Could not update the members",
      MODIFY_TEAM: "Modify team",
      NO_MACHINES: "No machines available",
      OEE: "OEE",
      FAULT: "Fault",
      CORRECTIVE: "Corrective",
      PREVENTIVE: "Preventive",
      SELECT_DEVICE_MODE: "Mode",
      MAINTENANCE: "Maintenance",
      AUTOMATIC: "Automatic",
      DEFAULT_MACHINES: "Default machines",
      MAXIMUM_DIFFERENCE_BETWEEN_REPORTED_AND_COUNTED_PIECES:
        "Maximum difference between reported and counted pieces",
      MAXIMUM_DIFFERENCE_EXCEEDED: "Maximum difference exceeded",
      SHOW_INPUT_KG_UNIT_LOT: "Show input for kg/unit and lot",
      KG_UNIT: "kg/unit",
      LOT: "Lot",
      BOX_CODE: "Box code",
      SHOW_BOX_CODE: "Show box code",
      SOCKET_LOCAL_DISCONNECTED: "Socket Local Disconnected",
      SOCKET_LOCAL_DISCONNECTED_ERROR:
        "The local socket connection is lost, the application cannot work properly",
      TESTS: "Tests",
      RESPONSIBLE_PRODUCCION: "Responsible Production",
      END: "End",
      NOK: "NOK",
      METERS: "Meters",
      LITERS: "Liters",
      BOXES: "Boxes",
      KG: "Kg",
      SACKS: "Sacks",
      NOK_JUSTIFIED_UNIT: "NOK justified {{unit}}",
      TOTAL_UNIT_NOK: "Total {{unit}} NOK",
      SHOW_STOP_SCREEN: "Show total stops screen",
      PER_CYCLE: "per cycle",
      TOTAL_PLANNED_STOPS: "Total planned stops",
      INCORRECT_USER_CODE: "Incorrect user code",
      PRODUCTIVITY: "Productivity",
      SHOW_DIVIDE_CONTAINER: environment.eurogerm
        ? "Show divide cycle"
        : "Show divide container",
      CLOSE_CONTAINER: environment.eurogerm ? "Close cycle" : "Close container",
      FROM_PREVIOUS_PRODUCTION: "From previous productions",
      WAITING_BAR_CODE_LECTURE: "Waiting for barcode Reading",
      ENTER_CODE_MANUALY: "Enter code manually",
      SELECT_COMPONENT: "Select component",
      LOTS_ENTERED: "Lots entered",
      QUANTITY_CANT_BE_ZERO: "Quantity can't be 0 or less than 0",
      QUANTITY_CANT_BE_LESS_ZERO: "Quantity can't be less than 0",
      QUANTITY_CANT_BE_EDITED: "Could not edit quantity",
      NO_COMPONENTS: "There are no components",
      ERROR_SAVING_DATA: "Error saving data",
      SURE_YOU_WANT_TO_LEAVE: "You sure want to go out",
      CHANGES_WILL_NOT_BE_SAVED:
        "If you have made changes, they will not be saved",
      ALL_IN_ONE_CONTAINER: environment.eurogerm
        ? "All in one cycle"
        : "All in one container",
      NO_CONTAINERS: environment.eurogerm
        ? "No cycles available"
        : "No containers available",
      SELECT_NEW_CONTAINER: environment.eurogerm
        ? "Select new cycle"
        : "Select new container",
      ASK_FOR_MEASURES: "Ask for the measurements",
      HIDE_CADENCE: "Hide cadence",
      SHOW_CADENCE: "Show cadence",
      WARNING: "Warning",
      MACHINE_NOT_READY: "The machine is not ready yet",
      DB_PRINT_TEMPLATE_BUTTON: "DB PRINT template button",
      PRODUCTION_START_COMMANDS: "Commands to send when production is started",
      MASTER_SLAVE_MODE: "Master/Slave mode",
      NEXT_CONTAINER_NOT_SCANNED_COMPONENTS: environment.eurogerm
        ? "The components for the next cycle have not been verified, you must verify them before continuing"
        : "The components for the next container have not been verified, you must verify them before continuing",
      ADD_PREPARATION_COMPONENT: "Add preparation component",
      ADD_COMPONENTS: "Add componentes",
      COMPONENT_CODE: "Component code",
      COMPONENT: "Component",
      USE_PREVIOUS_LOTS: "Use previous lots",
      PREVIOUS_LOTS: "Previous lots",
      ADD_PRODUCTION_COMPONENT: "Add component",
      TEXT_PRODUCTION_BUTTON: "Production button text",
      TIME_INTERVAL_BUTTON: "Time interval for production button",
      HIDE_PRODUCTION_DETAIL: "Hide production detail",
      STATION_NAME_REQUIRED: "Station name required",
      STATION_NAME_REQUIRED_MSG:
        "The station name is required to be able to send/modify a configuration",
      STATION_NAME: "Station name",
      EXPORT_CONFIGURATION: "Export",
      EDIT_CONFIGURATION: "Edit",
      IMPORT_CONFIGURATION: "Import",
      CONFIGURATIONS: "Configurations",
      NO_CONFIGURATIONS: "Without configurations",
      IMPORT_CONFIGURATION_QUESTION: "Import configuration?",
      IMPORT_CONFIGURATION_QUESTION_MSG:
        "Do you wish to import and overwrite the current configuration?",
      SAVE: "Save",
      SAVE_ALL_LOCAL: "Save all locally",
      GENERAL_TIME_INTERVAL_BUTTON:
        "General time interval for production buttons",
      VERIFY_COMPONENTS: "Verify components",
      VERIFY_COMPONENTS_ERROR: "You should verify the components before",
      DB_PRINT_CONTAINER_TEMPLATE: environment.eurogerm
        ? "Commands to send when cycle is closed"
        : "Commands to send when container is closed",
      CLIENT_NOT_CONFIGURED: "You must configure the client",
      THE_SPECIFIED_CONTAINER_DOES_NOT_EXIST: environment.eurogerm
        ? "The specified cycle does not exist"
        : "The specified container does not exist",
      NEXT_CONTAINER_CODE: environment.eurogerm
        ? "Code of the next cycle"
        : "Code of the next container",
      EMPTY_NEXT_CONTAINER_CODE: environment.eurogerm
        ? "The code of the next cycle cannot be empty, if you want to end the production do it directly"
        : "The code of the next container cannot be empty, if you want to end the production do it directly",
      CONTAINERS: environment.eurogerm ? "Cycles" : "Containers",
      ACTIVE_CONTAINERS: environment.eurogerm
        ? "Active cycles"
        : "Active containers",
      PENDING_CONTAINERS: environment.eurogerm
        ? "Pending cycles"
        : "Pending containers",
      NO_ACTIVE_CONTAINERS: environment.eurogerm
        ? "No active cycles"
        : "No active containers",
      NO_PENDING_CONTAINERS: environment.eurogerm
        ? "No pending cycles"
        : "No pending containers",
      NETWORK_SETTINGS: "Network settings",
      EDIT_NETWORK_SETTINGS: "Edit network settings",
      PASSWORD: "Password",
      ADAPTER: "Adapter",
      ROUND_COUNT: "Round total count",
      SELECT_CONTAINER: "Select container",
      CONTAINERS_EMPTY: "No containers",
      CLOSED_CONTAINERS: "Closed containers",
      CHANGE_OF: "Change OF",
      SHOW_CHANGE_OF_BUTTON: 'Show "Change OF" button',
      TOOLING: "Tooling",
      AUTO_START_PRODUCTION_MODE: "Auto start production mode",
      MINIMUM_CADENCE: "Minimum cadence",
      MINIMUM_TIME: "Minimum time",
      CHANGE_REFERENCE: "Change reference",
      TOTAL_OF: "Total quantity OF",
      PRODUCED: "Produced",
      MUST_START_MASTER_PRODUCTION_BEFORE:
        'You must start the production on the "Master" machine',
      MASTER_IN_USE:
        'The "Master" machine is being used by another worker, check if the previous productions were closed',
      MUST_CLOSE_PRODUCTION_FROM_MASTER:
        'You must close the production from the "Master" machine',
      GENERAL: "General",
      CLOUD: "Cloud",
      BUTTONS: "Buttons",
      COMMANDS: "Commands",
      SHOW_JUSTIFY_NOK_BUTTON: 'Show "Justify NOK" button',
      PRODUCTION_BUTTONS_VISIBLE: "Production buttons visible",
      LOTS: "Lots",
      LOCATION: "Location",
      DISABLE_ABILITY_TO_CHANGE_OK_NOK:'Disable the ability to change the total of OK and NOK quantities',
      ROUND_COUNT_TO_NEAREST_HALF: "Round total count to the nearest half",
      SELECT_A_COMPONENT: "Select a component",
    },
    FOOTER: {},
  },
};
